export default __webpack_public_path__ + "static/media/close-light.b38dd350.svg";